<template>
  <div class="comp-dashboard-field-setting">
    <jw-modal popup-container=".comp-dashboard-field-setting" width="350px" class="field-setting-modal" :visible="visible" title-align="start" :body-style="{ paddingBottom: 0, paddingTop: 0, paddingLeft: '8px', paddingRight: '8px' }" hide-title @cancel="closeSetModal" @ok="handleOk">
      <jw-spin :loading="isLoading" style="width: 100%">
        <div class="modal-title">{{ $t('卡片配置') }}</div>
        <div class="modal-input">
          <jw-input :placeholder="$t('搜索字段名称')" v-model="searchText">
            <template #suffix>
              <qfei-icon-search-two-outlined />
            </template>
          </jw-input>
        </div>
        <template v-if="getEntityFieldsShow()">
          <draggable :disabled="searchText" :sort="true" :animation="200" itemKey="fieldKey" :list="entityFields" class="drag-box">
            <template #item="{ element }">
              <div class="field-box" v-if="!searchText || element?.fieldName?.includes(searchText)">
                <div>
                  <qfei-icon-more-two-outlined class="drag-mover" :class="{ iconHide: searchText }" />
                  <component class="field-icon" :is="fieldIconMapping[element?.fieldType]" />
                  <span class="field-text" :title="element?.fieldName"> {{ element?.fieldName }} </span>
                </div>
                <jw-switch :disabled="element?.mainField" v-model="element.checked" />
              </div>
            </template>
          </draggable>
          <div class="field-mul-box">
            <jw-button long @click="toggleFieldSwitch(true)">{{ $t('显示全部') }}</jw-button>
            <jw-button long @click="toggleFieldSwitch(false)">{{ $t('隐藏全部') }}</jw-button>
          </div>
          <div class="field-box hide-box">
            {{ $t('隐藏字段名') }}
            <jw-switch v-model="isHideLabel" />
          </div>
        </template>
        <template v-else>
          <div class="no-data-svg">
            <jw-empty :img-src="noDataSvg" :description="t('暂无有效选项')"></jw-empty>
          </div>
        </template>
      </jw-spin>
    </jw-modal>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { setService } from '@/api';
import draggable from 'vuedraggable';
import useFields from '@/hooks/fields';
import { layoutService } from '@/api';
import { useI18n } from 'vue-i18n';
import { Message } from '@arco-design/web-vue';
import noDataSvg from '@/assets/images/no-data-150.svg';
import { useMainTableStore } from '@/store';
const useTableInfo = useMainTableStore();
const { t } = useI18n();
const { fieldIconMapping } = useFields();
const emits = defineEmits('cb');
const props = defineProps({
  entity: {
    type: [String, Number],
    default: ''
  },
  viewId: {
    type: [String, Number],
    default: ''
  },
  fields: {
    type: Array,
    default: () => []
  },
  //是否隐藏看板label 1.隐藏 0.展示
  businessData: {
    type: String,
    default: '0'
  }
});

const isLoading = ref(false);
const visible = ref(false);
const searchText = ref('');
const isHideLabel = ref(false);
const closeSetModal = () => {
  visible.value = false;
};
const open = () => {
  visible.value = true;
  isHideLabel.value = props.businessData === '1';
  getFields();
};
const entityFields = ref([]);
const getFields = async () => {
  try {
    isLoading.value = true;
    const res = await setService.getFormDesignFields({ entity: props.entity });
    isLoading.value = false;
    const _selectedFields = [];
    const _fieldKeys = [];
    props?.fields?.forEach((field) => {
      _selectedFields.push({
        ...field,
        checked: true
      });
      _fieldKeys.push(field?.fieldKey);
    });
    if (!res?.error) {
      entityFields.value = _selectedFields.concat(
        (res?.result || [])
          ?.filter((v) => !_fieldKeys.includes(v?.fieldKey) && v?.fieldType != 27) //过滤子表单
          ?.map((v) => {
            return {
              ...v,
              checked: false
            };
          })
      );
    } else {
      Message.error(res?.error?.msg || t('获取数据失败'));
    }
  } catch (e) {
    isLoading.value = false;
    console.log(e);
  }
};

const getEntityFieldsShow = () => {
  if (searchText.value) {
    const _array = entityFields.value.filter((v) => v?.fieldName?.includes(searchText.value));
    return _array?.length > 0;
  }
  return true;
};

const toggleFieldSwitch = (flag) => {
  entityFields.value = entityFields.value.map((v) => {
    v.checked = v?.mainField ? true : flag; //主属性字段永远为true
    return v;
  });
};
const handleOk = async () => {
  try {
    const _selectFields = entityFields.value.filter((v) => v.checked);
    const params = {
      id: props.viewId,
      fields: _selectFields.map((v) => v?.fieldKey),
      hideFieldName: isHideLabel.value ? '1' : '0'
    };
    const res = await layoutService.setDashboardFields(params);
    if (!res?.error) {
      closeSetModal();
      useTableInfo.setColumnFieldList?.(_selectFields);
      emits('cb', {
        fields: _selectFields,
        hideFieldName: isHideLabel.value
      });
    } else {
      Message.error(res?.error?.msg || t('操作失败'));
    }
  } catch (e) {
    console.log(e);
  }
};
defineExpose({ open });
</script>
<style scoped lang="less">
@import './dashboard-field-setting.less';
</style>
